import CurtainIcon from '@/assets/icons/measurement/curtain.png';
import FanIcon from '@/assets/icons/measurement/fan.png';
import FertigationIcon from '@/assets/icons/measurement/fertigation.png';
import HeaterIcon from '@/assets/icons/measurement/heater.png';
import HumidifierIcon from '@/assets/icons/measurement/humidifier.png';
import HumidityIcon from '@/assets/icons/measurement/humidity.png';
import IrrigationIcon from '@/assets/icons/measurement/irrigation.png';
import LightIcon from '@/assets/icons/measurement/light.png';
import TemperatureIcon from '@/assets/icons/measurement/temperature.png';
import WindowIcon from '@/assets/icons/measurement/window.png';

export const iconMap: Record<string, string> = {
  curtain: CurtainIcon,
  fan: FanIcon,
  fertigation: FertigationIcon,
  heater: HeaterIcon,
  humidifier: HumidifierIcon,
  humidity: HumidityIcon,
  irrigation: IrrigationIcon,
  light: LightIcon,
  temperature: TemperatureIcon,
  window: WindowIcon
};
